<ion-fab-button
  #prevBtn
  *ngIf="!firstPage && !isFactsheet"
  (click)="prev.emit(true)"
>
  <ion-icon name="arrow-back"></ion-icon>
</ion-fab-button>

<ion-button
  [class.bp-rtl]="document.dir === 'rtl'"
  #saveBtn
  class="align-right-save"
  shape="round"
  strong
  *ngIf="lastPage && !readonly && !hideSelector && !isFactsheet"
  (click)="next.emit(true)"
>
  {{ 'SAVE' | translate }}
</ion-button>

<ion-button
  [class.bp-rtl]="document.dir === 'rtl'"
  #nextButton
  class="align-right-save"
  shape="round"
  strong
  *ngIf="isFactsheet"
  (click)="nextFactsheet()"
>
  {{ 'NEXT' | translate }}
</ion-button>

<ion-fab-button
  [class.bp-rtl]="document.dir === 'rtl'"
  #nextBtn
  class="align-right-next"
  *ngIf="!lastPage && !isFactsheet"
  (click)="next.emit(true)"
>
  <ion-icon name="arrow-forward"></ion-icon>
</ion-fab-button>
